import { CodeOwnershipApi } from '@appfolio/backstage-plugin-code-ownership-common';
import { createApiRef } from '@backstage/core-plugin-api';

export const codeOwnershipApiRef = createApiRef<CodeOwnershipApi>({
  id: 'plugin.code-ownership.service',
});
